module.exports = __webpack_public_path__ + "img/img4.9802053e.jpg";